import {createFetchActions} from '../../services/createActions'
import {get} from '../../services/createAPICall'
import {getPMSBaseUrl} from '../../services/apiService'

export const GROUPED_PORTFOLIO_ENTRY = createFetchActions('GROUPED_PORTFOLIO_ENTRY')

export const getGroupedPortfolioEntry = () => (dispatch: any) => {
	return dispatch(get(GROUPED_PORTFOLIO_ENTRY, `${getPMSBaseUrl()}/v1/portfolios/portfolio-entry-groupBy-securityId`))
}
